import { render, staticRenderFns } from "./StateChemistryDistricts.vue?vue&type=template&id=39ed016a&scoped=true&"
import script from "./StateChemistryDistricts.vue?vue&type=script&lang=js&"
export * from "./StateChemistryDistricts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed016a",
  null
  
)

export default component.exports